import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCustomField } from "./customField.hooks.ts";
import { setFirstLetterToLowerCase } from "../../../common/stringOperations.ts";
import { InputFieldTypeEnum } from "../../inputFields/InputFields.types.ts";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useSelectableLegalEntityQuery } from "../../../legalEntity/useSelectableLegalEntityQuery.ts";

export interface CustomLegalEntityFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    isLoading: boolean;
    entityId: string;
    entityApiPath: string;
    customInputFieldId: string;
    fieldName: string;
    fieldDescription: string | undefined;
    values: Array<string>;
    onChange: (changeFunc: (entity: any) => void) => void;
    readOnly?: boolean;
    isDisabled: boolean;
    errorText?: string;
    isPreview: boolean;
}

function CustomLegalEntityField(props: CustomLegalEntityFieldProps) {
    const { translateString } = useTranslation();
    const { onFieldChange } = useCustomField(props.entityApiPath, props.entityId, props.customInputFieldId, props.onChange);

    const { isLoading, data } = useSelectableLegalEntityQuery(!props.isPreview);

    return (
        <DotLegalMultiSelect
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            isLoading={props.isLoading || isLoading}
            options={data ?? []}
            chosenOptions={props.values}
            onChange={
                props.readOnly
                    ? () => {}
                    : (values) => {
                          onFieldChange(values);
                      }
            }
            label={props.fieldName!}
            toolTipText={props.fieldDescription}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.isDisabled}
            errorText={props.errorText}
            helperText={
                props.isPreview ? translateString(setFirstLetterToLowerCase(InputFieldTypeEnum[InputFieldTypeEnum.MultiDropDown].toString())) : undefined
            }
        />
    );
}

export default CustomLegalEntityField;
